<template>
  <v-container fluid class="contract-detail" v-if="contract && contract_year">
    <v-row class="flex-grow-0">
      <v-btn
        text
        x-small
        color="primary"
        exact
        :to="{ name: 'contract-detail', params: { contractId: contract.id } }"
      >
        &lt;&lt; Contract Details ({{ contract_year.year }})
      </v-btn>
    </v-row>
    <v-row class="rbu-section-info-wrapper" style="height: 60px">
      <div
        style="
          display: flex;
          justify-content: space-between;
          width: 100%;
          margin-left: 1rem;
        "
      >
        <h3></h3>
        <div>
          <v-btn color="primary" class="ml-4" small @click="goToConfig">
            Configure
          </v-btn>
        </div>
      </div>
    </v-row>
    <v-row>
      <ASorSectionList
        :extra-filters="{
          contract: [contract.id],
          contract_year: [$route.params.contract_percentage_id],
        }"
      />
    </v-row>
  </v-container>
</template>

<script>
import { ref, onMounted } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";
import ASorSectionList from "@/components/asor/ASorSectionList.vue";
export default {
  name: "ContractPercentageFluctuationList",
  components: {
    ASorSectionList,
  },
  setup(props, { root }) {
    const contract = ref(null);
    const contract_year = ref(null);
    const getContract = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/contract/",
        params: { contract_id: root.$route.params.contractId },
      });

      if (response.body.success) {
        contract.value = response.body.contract;
      }
    };

    const getContractPercentageYear = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/contract/contract_percentage/contract_percentage_year/",
        params: {
          contract_percentage_id: root.$route.params.contract_percentage_id,
        },
      });

      if (response && response.data && response.data.success) {
        contract_year.value = response.data.contract_percentage_year;
      }
    };

    const goToConfig = async function () {
      root.$router.push({ name: "contract-percentage-year-config" });
    };

    onMounted(async () => {
      await root.$store.dispatch(ACTION_TYPES.GET_ME);
      getContract();
      getContractPercentageYear();
    });
    return {
      contract,
      contract_year,
      goToConfig,
    };
  },
};
</script>
